import { type Model } from 'flexlayout-react';
import { useEffect, type RefObject } from 'react';

import { SettingView } from 'app/modules/wallforming/components/setting-container/types/settingView';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

interface SettingOptionsLayoutProps {
    catalogueViewRef: RefObject<HTMLDivElement | null>;
    placementViewRef: RefObject<HTMLDivElement | null>;
    prevSettingViewRef: RefObject<SettingView | null>;
    settingModelRef?: RefObject<Model | null>;
}

export const useSettingEventHandler = ({
    catalogueViewRef,
    placementViewRef,
    prevSettingViewRef
}: SettingOptionsLayoutProps) => {
    // Keep focus in sync with the active setting view; visibility is derived by the layout.
    useEffect(() => {
        const unsubscribe = usePlacementStore.subscribe(
            (state) => state.selectedSettingView,
            (newSettingView) => {
                const previousViewRef =
                    prevSettingViewRef.current === SettingView.CATALOGUE
                        ? catalogueViewRef
                        : prevSettingViewRef.current === SettingView.AUTOMATED_PLACEMENT
                          ? placementViewRef
                          : null;
                const activeElement = document.activeElement;
                if (activeElement instanceof HTMLElement && previousViewRef?.current?.contains(activeElement)) {
                    activeElement.blur();
                }

                prevSettingViewRef.current = newSettingView;
            }
        );

        return unsubscribe;
    }, [catalogueViewRef, placementViewRef, prevSettingViewRef]);
};
